// ????????????????????????????????????????????????????????????
// Sidebar Menu Renderer + Navigation
// ????????????????????????????????????????????????????????????
// Data source: CF.user.menus (populated by cf-auth.js ? loadMe())
// Sidebar starts empty; renderSidebarFromMe() is called by cf-auth.js
// after /api/v1/auth/me succeeds.
//
// CF.user.menus is a tree: [{ id, name, code, url, icon, children }]
// This file transforms that into NAV_MENU format and renders sidebar,
// breadcrumb, and collapsed flyout panel.
// ????????????????????????????????????????????????????????????

// ?? Menu Group mapping ??????????????????????????
// Maps L1 menu Code ? sidebar group label.
// PETAKAN SEMUA kode L1 secara eksplisit — kode yang tidak terdaftar
// mewarisi grup item sebelumnya (dulu Master Data dkk "nyangkut" di
// bawah Monitoring karena ini). Urutan tampil mengikuti OrderIndex
// tb_M_Menus (script 053).
var MENU_GROUP_MAP = {
    // Workspace — menu harian semua pengguna
    'DASHBOARD':          'Workspace',
    'TASK_APPROVAL':      'Workspace',
    'ABSENSI':            'Workspace',
    'EXPORTS':            'Workspace',
    // Control Center — pemantauan & laporan operasional
    'MONITORING':         'Control Center',
    'MONITORING_ABSENSI': 'Control Center',
    'MAP_AREA':           'Control Center',
    'REPORT':             'Control Center',
    // Lainnya
    'MASTER':             'Master Data',
    'SETTING':            'Administrasi',
    'LOG':                'Administrasi'
};

// ?? NAV_MENU � populated by renderSidebarFromMe() ??
var NAV_MENU = [];

// ?? State ???????????????????????????????????????
var sidebarCollapsed  = false;
var mobileSidebarOpen = false;
var flyoutHideTimer   = null;
var flyoutShowTimer   = null;
var currentFlyoutId   = null;

// ????????????????????????????????????????????????
// TRANSFORM: MeResponse.menus[] ? NAV_MENU format
// Converts API menu tree into the shape the renderer expects:
//   { id, label, icon, href, group, children }
// ????????????????????????????????????????????????
function _transformMenuTree(apiMenus, isRoot) {
    if (!apiMenus || !apiMenus.length) return [];
    return apiMenus.map(function (m) {
        var node = {
            id:    m.code ? m.code.toLowerCase().replace(/_/g, '-') : m.id,
            label: m.name,
            icon:  m.icon || null,
            href:  m.url || null
        };
        if (isRoot && MENU_GROUP_MAP[m.code]) {
            node.group = MENU_GROUP_MAP[m.code];
        }
        if (m.children && m.children.length > 0) {
            node.children = _transformMenuTree(m.children, false);
        }
        return node;
    });
}

// ????????????????????????????????????????????????
// PUBLIC: called by cf-auth.js after loadMe() succeeds
// ????????????????????????????????????????????????
window.renderSidebarFromMe = function (menus) {
    NAV_MENU = _transformMenuTree(menus, true);
    buildSidebarNav();
    markActivePage();
    buildBreadcrumb();
};

// ????????????????????????????????????????????????
// BUILD SIDEBAR NAV FROM NAV_MENU
// ????????????????????????????????????????????????
function buildSidebarNav() {
    var nav = document.getElementById('sidebar-nav');
    if (!nav) return;

    var currentGroup = '';
    var html = '';

    NAV_MENU.forEach(function (item) {
        if (item.group && item.group !== currentGroup) {
            currentGroup = item.group;
            html += '<div class="sb-group-label">' + item.group + '</div>';
        }
        html += buildL1(item);
    });

    nav.innerHTML = html;
}

function buildL1(item) {
    if (!item.children) {
        return '<a href="' + (item.href || '#') + '" onclick="return setActive(this)"' +
            ' class="nav-leaf" data-solo-tooltip="' + item.label + '">' +
            '<i class="fa-solid ' + (item.icon || 'fa-circle') + ' sidebar-icon"></i>' +
            '<span class="sb-label">' + item.label + '</span>' +
            '</a>';
    }

    return '<div class="nav-group">' +
        '<button class="nav-parent-btn"' +
            ' onclick="handleL1Click(this,\'' + item.id + '\')"' +
            ' onmouseenter="handleL1Hover(this,\'' + item.id + '\')"' +
            ' onmouseleave="scheduleFlyoutHide()"' +
            ' data-group-id="' + item.id + '">' +
            '<div class="nav-item-inner">' +
                '<i class="fa-solid ' + (item.icon || 'fa-circle') + ' sidebar-icon"></i>' +
                '<span class="sb-label">' + item.label + '</span>' +
            '</div>' +
            '<i class="fa-solid fa-chevron-right nav-arrow sb-label"></i>' +
        '</button>' +
        '<div class="nav-submenu" style="padding-left:12px">' +
            item.children.map(buildL2).join('') +
        '</div>' +
    '</div>';
}

function buildL2(child) {
    if (!child.children) {
        var iconHtml = child.icon
            ? '<i class="fa-solid ' + child.icon + ' sidebar-icon" style="width:16px;font-size:12px"></i>'
            : '';
        return '<a href="' + (child.href || '#') + '" onclick="return setActive(this)" class="nav-leaf">' +
            iconHtml +
            '<span class="sb-label">' + child.label + '</span>' +
        '</a>';
    }

    return '<div class="nav-group">' +
        '<button class="nav-parent-btn" onclick="toggleNavItem(this)" style="padding:7px 12px">' +
            '<div class="nav-item-inner">' +
                (child.icon ? '<i class="fa-solid ' + child.icon + ' sidebar-icon" style="width:16px;font-size:12px"></i>' : '') +
                '<span class="sb-label" style="font-size:12.5px">' + child.label + '</span>' +
            '</div>' +
            '<i class="fa-solid fa-chevron-right nav-arrow sb-label" style="font-size:10px;color:#CBD5E1"></i>' +
        '</button>' +
        '<div class="nav-submenu" style="padding-left:12px">' +
            child.children.map(function (gc) {
                return '<a href="' + (gc.href || '#') + '" onclick="return setActive(this)" class="nav-leaf" style="font-size:12px">' +
                    '<span class="leaf-dot"></span>' +
                    '<span class="sb-label">' + gc.label + '</span>' +
                '</a>';
            }).join('') +
        '</div>' +
    '</div>';
}

// ????????????????????????????????????????????????
// ACTIVE STATE
// ????????????????????????????????????????????????
function setActive(el) {
    document.querySelectorAll('.nav-leaf').forEach(function (l) { l.classList.remove('active'); });
    el.classList.add('active');
    if (isMobile()) closeMobileSidebar();
    return true;
}

function markActivePage() {
    var currentPath = window.location.pathname;
    document.querySelectorAll('.nav-leaf').forEach(function (leaf) {
        var href = leaf.getAttribute('href') || '';
        if (href && href !== '#' && currentPath.toLowerCase() === href.toLowerCase()) {
            leaf.classList.add('active');
            // Expand parent submenus
            var parent = leaf.closest('.nav-submenu');
            while (parent) {
                parent.classList.add('open');
                var arrow = parent.previousElementSibling
                    ? parent.previousElementSibling.querySelector('.nav-arrow')
                    : null;
                if (arrow) arrow.classList.add('rotated');
                var parentEl = parent.parentElement ? parent.parentElement.closest('.nav-submenu') : null;
                parent = parentEl;
            }
        }
    });
}

// ????????????????????????????????????????????????
// AUTO BREADCRUMB from NAV_MENU
// ????????????????????????????????????????????????
function buildBreadcrumb() {
    var el = document.getElementById('breadcrumb');
    if (!el) return;

    var path = window.location.pathname.toLowerCase();

    if (path === '/' || path === '') {
        el.style.display = 'none';
        return;
    }

    var trail = findBreadcrumbTrail(NAV_MENU, path, []);
    if (!trail) {
        el.style.display = 'none';
        return;
    }

    var html = '<a href="/" class="bc-item"><i class="fa-solid fa-house"></i> Home</a>';

    for (var i = 0; i < trail.length; i++) {
        html += '<i class="fa-solid fa-chevron-right bc-sep"></i>';
        if (i === trail.length - 1) {
            html += '<span class="bc-current">' + trail[i].label + '</span>';
        } else {
            html += '<span class="bc-item">' + trail[i].label + '</span>';
        }
    }

    el.innerHTML = html;
    el.style.display = '';
}

function findBreadcrumbTrail(items, targetPath, parentTrail) {
    for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var currentTrail = parentTrail.concat([{ label: item.label }]);

        if (item.href && item.href.toLowerCase() === targetPath) {
            return currentTrail;
        }

        if (item.children) {
            var found = findBreadcrumbTrail(item.children, targetPath, currentTrail);
            if (found) return found;
        }
    }
    return null;
}

// ????????????????????????????????????????????????
// SIDEBAR TOGGLE
// ????????????????????????????????????????????????
function isMobile() { return window.innerWidth < 768; }

function toggleSidebar() {
    if (isMobile()) {
        mobileSidebarOpen = !mobileSidebarOpen;
        document.getElementById('sidebar').classList.toggle('mobile-open', mobileSidebarOpen);
        var bd = document.getElementById('sidebar-backdrop');
        if (bd) bd.classList.toggle('show', mobileSidebarOpen);
    } else {
        sidebarCollapsed = !sidebarCollapsed;
        var sb = document.getElementById('sidebar');
        var fi = document.getElementById('footer-icon');
        sb.classList.toggle('collapsed', sidebarCollapsed);
        if (fi) fi.classList.toggle('hidden', !sidebarCollapsed);
        if (sidebarCollapsed) {
            hideFlyout();
            collapseAllNavItems();
        }
    }
}

function collapseAllNavItems() {
    document.querySelectorAll('.nav-submenu.open').forEach(function (s) { s.classList.remove('open'); });
    document.querySelectorAll('.nav-arrow.rotated').forEach(function (a) { a.classList.remove('rotated'); });
}

function closeMobileSidebar() {
    mobileSidebarOpen = false;
    document.getElementById('sidebar').classList.remove('mobile-open');
    var bd = document.getElementById('sidebar-backdrop');
    if (bd) bd.classList.remove('show');
}

window.addEventListener('resize', function () {
    if (!isMobile()) {
        var bd = document.getElementById('sidebar-backdrop');
        if (bd) bd.classList.remove('show');
        document.getElementById('sidebar').classList.remove('mobile-open');
        mobileSidebarOpen = false;
    } else {
        document.getElementById('sidebar').classList.remove('collapsed');
        hideFlyout();
    }
});

// ????????????????????????????????????????????????
// NAV ACCORDION
// ????????????????????????????????????????????????
function toggleNavItem(btn) {
    var group   = btn.closest('.nav-group');
    var submenu = group.querySelector(':scope > .nav-submenu');
    var arrow   = btn.querySelector('.nav-arrow');
    var isOpen  = submenu.classList.contains('open');
    submenu.classList.toggle('open', !isOpen);
    if (arrow) arrow.classList.toggle('rotated', !isOpen);
}

function handleL1Click(btn, id) {
    if (!isMobile() && sidebarCollapsed) {
        var flyout = document.getElementById('nav-flyout');
        if (flyout.classList.contains('visible') && currentFlyoutId === id) {
            hideFlyout();
        } else {
            showFlyout(id, btn);
        }
        return;
    }
    toggleNavItem(btn);
}

function handleL1Hover(btn, id) {
    if (!isMobile() && sidebarCollapsed) {
        cancelFlyoutHide();
        flyoutShowTimer = setTimeout(function () { showFlyout(id, btn); }, 120);
    }
}

// ????????????????????????????????????????????????
// FLYOUT PANEL
// ????????????????????????????????????????????????
function showFlyout(id, anchor) {
    var menu = null;
    for (var i = 0; i < NAV_MENU.length; i++) {
        if (NAV_MENU[i].id === id) { menu = NAV_MENU[i]; break; }
    }
    if (!menu || !menu.children) return;

    currentFlyoutId = id;
    var flyout = document.getElementById('nav-flyout');

    var bodyHtml = '';
    menu.children.forEach(function (child) {
        if (child.children) {
            bodyHtml +=
                '<div>' +
                    '<button class="flyout-group-btn" onclick="toggleFlyoutGroup(this)">' +
                        '<span class="flyout-group-left">' +
                            (child.icon ? '<i class="fa-solid ' + child.icon + ' group-icon"></i>' : '') +
                            '<span>' + child.label + '</span>' +
                        '</span>' +
                        '<i class="fa-solid fa-chevron-right flyout-arrow-icon"></i>' +
                    '</button>' +
                    '<div class="flyout-sub">' +
                        child.children.map(function (gc) {
                            return '<a href="' + (gc.href || '#') + '" class="flyout-sub-item">' +
                                '<span class="flyout-dot"></span>' + gc.label +
                            '</a>';
                        }).join('') +
                    '</div>' +
                '</div>';
        } else {
            bodyHtml +=
                '<a href="' + (child.href || '#') + '" class="flyout-item">' +
                    (child.icon ? '<i class="fa-solid ' + child.icon + '"></i>' : '') +
                    '<span style="flex:1">' + child.label + '</span>' +
                '</a>';
        }
    });

    flyout.innerHTML =
        '<div class="flyout-header">' +
            '<i class="fa-solid ' + (menu.icon || 'fa-circle') + '"></i>' +
            '<span>' + menu.label + '</span>' +
        '</div>' +
        '<div class="flyout-body">' + bodyHtml + '</div>';

    var rect = anchor.getBoundingClientRect();
    var estH = Math.min(menu.children.length * 42 + 60, window.innerHeight - 80);
    flyout.style.top = Math.max(8, Math.min(rect.top, window.innerHeight - estH - 16)) + 'px';
    flyout.classList.add('visible');
}

function hideFlyout() {
    currentFlyoutId = null;
    var flyout = document.getElementById('nav-flyout');
    if (flyout) flyout.classList.remove('visible');
}

function cancelFlyoutHide() {
    clearTimeout(flyoutHideTimer);
    clearTimeout(flyoutShowTimer);
}

function scheduleFlyoutHide() {
    clearTimeout(flyoutShowTimer);
    flyoutHideTimer = setTimeout(hideFlyout, 250);
}

function toggleFlyoutGroup(btn) {
    var sub   = btn.nextElementSibling;
    var arrow = btn.querySelector('.flyout-arrow-icon');
    var isOpen = sub.classList.contains('open');
    document.querySelectorAll('.flyout-sub.open').forEach(function (s) {
        s.classList.remove('open');
        var prevArrow = s.previousElementSibling
            ? s.previousElementSibling.querySelector('.flyout-arrow-icon')
            : null;
        if (prevArrow) prevArrow.classList.remove('rotated');
    });
    if (!isOpen) {
        sub.classList.add('open');
        if (arrow) arrow.classList.add('rotated');
    }
}

// ????????????????????????????????????????????????
// EXPOSE GLOBALS � inline onXxx handlers require window scope
// ????????????????????????????????????????????????
window.handleL1Click      = handleL1Click;
window.handleL1Hover      = handleL1Hover;
window.scheduleFlyoutHide = scheduleFlyoutHide;
window.cancelFlyoutHide   = cancelFlyoutHide;
window.toggleNavItem      = toggleNavItem;
window.toggleFlyoutGroup  = toggleFlyoutGroup;
window.toggleSidebar      = toggleSidebar;
window.closeMobileSidebar = closeMobileSidebar;
window.setActive          = setActive;
